import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { FileImageOutlined } from '@ant-design/icons';
import { Text } from '@/components/Typography';
import { IconWrapper } from './styles';

export function UploadFileButton() {
	return (
		<Row>
			<IconWrapper span={24}>
				<FileImageOutlined />
			</IconWrapper>
			<Col span={24}>
				<Text>{I18n.get('Add file')}</Text>
			</Col>
		</Row>
	);
}
